import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import {setBackground} from "../../event.js";
import {DashboardItem} from "../../items/index.js";
import {widgetCalendar} from "../calendar-widget/index.js";
import {settingArr} from "./index.js";
import {setWidgetModule, widgetBoard} from "../../index.js";
import u from "../../../../util"

const init = async () => {
    clickEvent();
    keydownEvent();
}

const clickEvent = () => {
    $('#widget_setting').off('click').on('click', (e) => settingArea(e));
}

const settingArea = (e) => {
    //세팅닫기
    if ($(e.target).closest(".btn-close").length > 0 || $(e.target).closest(".dashboard-set-popup").length === 0) return hideSetting();

    //배경클릭시
    if ($(e.target).closest('.dashboard-color-pick-wrap input').length  > 0 || $(e.target).closest('.dashboard-bg-pick-wrap input').length > 0 ) {
        DashboardApi.getApi('setBackground',({WIDGET_NM: $(e.target).attr("id")}));
        setBackground($(e.target).attr("id"), $(e.target).attr("mode"))
    }

    //더보기
    if ($(e.target).closest('.dashboard-bg-more-button-wrap').length > 0 || $(e.target).closest('.icon-template-back').length > 0 ) {
        $('.dashboard-set-popup').toggleClass('d-none');
    }

    //의견보내기
    if ($(e.target).closest('.js-widget-opinion').length > 0 ) {
        const isMorningmate = window.location.href.includes('morningmate')
        const redirectUrl = isMorningmate? ' https://forms.gle/wCVJEMJHoqcpP6EJA' : 'https://forms.gle/yuYb2Hrei2dePdpj7'
        OpenUtil.openUrlOnBrowser(redirectUrl, true)
    }

    //위젯 아이템
    if ($(e.target).closest(".item:not(.js-add-disable) label, .wide-item:not(.js-add-disable) label").length > 0 ) {
        if($('#dashboardWrap > li[id!=""]').length >= 20){
            u.toast('error', i18next.t(main.widget.addUpto))
            return;
        }

        const $target = $(e.target).closest('.item, .wide-item');
        const WIDGET_SRNO = $target.find('input').attr('name');
        DashboardApi.getApi('AddWidget',({USER_ID:_USER_ID, WIDGET_SRNO}))
            .then((dat) => {
                u.toast('info', i18next.t(common.successAdd, {val: $t(dictionary.widget)}))
                globalValue.widgetInfo = ''
                $('#dashboardWrap').append(`${DashboardItem(dat)}`);
                setWidgetModule.bind(widgetBoard)(dat)
                $('.js-button-widget-add').css('display', 'none')
                removeWidget($target, WIDGET_SRNO);
                widgetCalendar();
            })
    }
}

const removeWidget = ($target, WIDGET_SRNO) => {
    if(settingArr[WIDGET_SRNO] > 0 && settingArr[WIDGET_SRNO] - $('#dashboardWrap').find(`li[srno=${WIDGET_SRNO}]`).length <= 0){
        $target.addClass('js-add-disable')
    }
}
const keydownEvent = () => {
    $(window).on("keydown", function (e) {
        e.stopPropagation();
        if (KeyCheck.isKey(e, "ESC")) {
            hideSetting()
        } else {
            //pass
        }
    });
}

const hideSetting = () => {
    // $('#widget_setting .dashboard-set-popup .popup-main').scrollTop(0);
    $('#widget_setting').css("display", "none");
    $('.dashboard-set-popup').removeClass('d-none');
    $('.dashboard-set-pick-wrap').addClass('d-none');
    document.getElementById('widget_setting').innerHtml = '';
}

const DashboardSettingEvent = {
    init,
}

export default DashboardSettingEvent;
